import type { TopClipLengthChoice } from "./topclipAutoApi";

export const TOPCLIP_CLIP_COUNT_MIN = 1;
export const TOPCLIP_CLIP_COUNT_PRODUCT_MAX = 10;
export const TOPCLIP_AUTO_CLIP_COUNT_CAP = 6;

const LENGTH_MIDPOINT_SECONDS: Record<TopClipLengthChoice, number> = {
  auto: 45,
  short: 22.5,
  medium: 45,
  long: 75,
};

const MANUAL_OVERLAP_FACTOR = 1.25;
const AUTO_OVERLAP_FACTOR = 1.6;

const isVerifiedDuration = (
  sourceDurationSeconds: number | null
): sourceDurationSeconds is number =>
  typeof sourceDurationSeconds === "number" &&
  Number.isFinite(sourceDurationSeconds) &&
  sourceDurationSeconds > 0;

const durationBound = ({
  sourceDurationSeconds,
  lengthChoice,
  overlapFactor,
  maximum,
}: {
  sourceDurationSeconds: number;
  lengthChoice: TopClipLengthChoice;
  overlapFactor: number;
  maximum: number;
}): number => {
  const midpoint = LENGTH_MIDPOINT_SECONDS[lengthChoice];
  return Math.min(
    maximum,
    Math.max(
      TOPCLIP_CLIP_COUNT_MIN,
      Math.floor(sourceDurationSeconds / (midpoint * overlapFactor))
    )
  );
};

export const getManualClipCountMaximum = ({
  sourceDurationSeconds,
  lengthChoice,
}: {
  sourceDurationSeconds: number | null;
  lengthChoice: TopClipLengthChoice;
}): number | null => {
  if (!isVerifiedDuration(sourceDurationSeconds)) return null;
  return durationBound({
    sourceDurationSeconds,
    lengthChoice,
    overlapFactor: MANUAL_OVERLAP_FACTOR,
    maximum: TOPCLIP_CLIP_COUNT_PRODUCT_MAX,
  });
};

export const getAutoClipCountTarget = ({
  sourceDurationSeconds,
  lengthChoice,
}: {
  sourceDurationSeconds: number | null;
  lengthChoice: TopClipLengthChoice;
}): number => {
  if (!isVerifiedDuration(sourceDurationSeconds)) {
    return TOPCLIP_AUTO_CLIP_COUNT_CAP;
  }
  return durationBound({
    sourceDurationSeconds,
    lengthChoice,
    overlapFactor: AUTO_OVERLAP_FACTOR,
    maximum: TOPCLIP_AUTO_CLIP_COUNT_CAP,
  });
};
